// extracted by mini-css-extract-plugin
module.exports =  {"title":"title_AAXhgx2p","option":"option_r6NTnXQX","divider":"divider_GpCN52xr"};